import { PatchPayload } from "../service"

export const ACTION_TYPES = {
    PATCH: "PATCH_INVENTORY_DATA" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.PATCH, id: string, payload: PatchPayload }



// WEBPACK FOOTER //
// ./src/state/inventory/data/actions/types.ts